import SmartButtonOutlinedIcon from '@mui/icons-material/SmartButtonOutlined';
import QrCodeOutlinedIcon from '@mui/icons-material/QrCodeOutlined';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';

const COLLECT_LOCAL_PAY_BENEFITS = [
  {
    icon: <SmartButtonOutlinedIcon className="text-[#016bf8] mb-2 !w-8 !h-8" />,
    description: 'clpBenefit1',
  },
  {
    icon: <QrCodeOutlinedIcon className="text-[#016bf8] mb-2 !w-8 !h-8" />,
    description: 'clpBenefit2',
  },
  {
    icon: <LocalAtmOutlinedIcon className="text-[#016bf8] mb-2 !w-8 !h-8" />,
    description: 'clpBenefit3',
  },
  {
    icon: <SavingsOutlinedIcon className="text-[#016bf8] mb-2 !w-8 !h-8" />,
    description: 'clpBenefit4',
  },
];

export default COLLECT_LOCAL_PAY_BENEFITS;
